export default (id) => ({
  0: '#114B8C',
  1: '#AFF2FD',
  3: '#288DD0',
  2: '#4FC4EF',
})[id];
